import React from 'react';

const LinkOptions = ({ editor }) => {
  return (
    <div className="linkOptions">
      <h3>Link</h3>
      {/* Options will be added later */}
    </div>
  );
};

export default LinkOptions;
